import { IonCol, IonRow } from "@ionic/react"
import { useEffect, useState } from "react"

import ActionButton from "../../components/button/ActionButton"

interface Props {
    doOnClick: "open" | "reload" | "reset"
}

const BackButton: React.FC<Props> = (props) => {
    const [href, setHref] = useState("");

    useEffect(() => {
        if (props.doOnClick == "open") {
            setHref("nazretabiat://open");
        } else if (props.doOnClick == "reload") {
            setHref("nazretabiat://open?reload");
        } else if (props.doOnClick == "reset") {
            setHref("nazretabiat://open?reset");
        }
    }, [props.doOnClick])

    return <IonRow>
        <IonCol>
            <ActionButton text="بازگشت به برنامه" color="blue" compact href={href} />
        </IonCol>
    </IonRow>
}

export default BackButton;